import { render } from "./Index.vue?vue&type=template&id=9ce3babc&scoped=true&ts=true"
import script from "./Index.vue?vue&type=script&lang=ts"
export * from "./Index.vue?vue&type=script&lang=ts"

import "./Index.vue?vue&type=style&index=0&id=9ce3babc&lang=scss&scoped=true"

import exportComponent from "C:\\work\\h5\\yulinxing\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9ce3babc"]])

export default __exports__